import React, { Component } from 'react';
import { useImage } from 'react-image'
import {imagePath} from '../common'
export function FullBannerComponent(props) {
    const { src } = useImage({
        srcList: imagePath+props.item.banner_image
    })
    return (
        <div className="bg_banner_sec w-left" style={{ backgroundImage: 'url(' +src+ ')', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', minHeight: '25vw' }}>
        <div className="bg_banner_txt">
            <h2>{props.item.banner_title}</h2>
            <p style={{}}>
                {props.item.banner_content}
            </p>
            <br />
            <a className="hvr-outline-out button2" onClick={() =>props.onClick()}>{props.item.banner_button}</a>
        </div>
    </div>
    )
}